export const stringCamelCaseToKebab = (str) =>
  str.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
